export function createInstanceId(prefix = "inst") {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export function deepClone(value) {
  if (value === undefined || value === null) return value;

  if (typeof structuredClone === "function") {
    return structuredClone(value);
  }

  return JSON.parse(JSON.stringify(value));
}

export function cloneNodeTree(node, prefix = "inst") {
  return {
    ...deepClone(node),
    id: createInstanceId(prefix),
    children: (node.children || []).map((child) =>
      cloneNodeTree(child, prefix)
    ),
  };
}

export function reIdNodeTree(node, prefix = "inst") {
  return {
    ...deepClone(node),
    id: createInstanceId(prefix),
    children: (node.children || []).map((child) =>
      reIdNodeTree(child, prefix)
    ),
  };
}

export function findNodeInTree(tree = [], nodeId) {
  for (const node of tree || []) {
    if (String(node.id) === String(nodeId)) return node;

    const child = findNodeInTree(node.children || [], nodeId);
    if (child) return child;
  }

  return null;
}

export function collectNodesByIds(tree = [], ids = []) {
  const idSet = new Set(ids.map(String));
  const result = [];

  function traverse(items = []) {
    items.forEach((node) => {
      if (idSet.has(String(node.id))) {
        result.push(node);
      }

      traverse(node.children || []);
    });
  }

  traverse(tree);

  return result;
}

export function removeNodesByIds(tree = [], ids = []) {
  const removeSet = new Set(ids.map(String));

  function remove(items = []) {
    return items
      .filter((node) => !removeSet.has(String(node.id)))
      .map((node) => ({
        ...node,
        children: remove(node.children || []),
      }));
  }

  return remove(tree);
}

export function createPastedNodesFromClipboard(clipboard = [], offset = 200) {
  return clipboard.map((node) => {
    const cloned = cloneNodeTree(node);

    return {
      ...cloned,
      transform: {
        ...(cloned.transform || {}),
        position: {
          x: Number(cloned.transform?.position?.x || 0) + offset,
          y: Number(cloned.transform?.position?.y || 0),
          z: Number(cloned.transform?.position?.z || 0) + offset,
        },
      },
    };
  });
}